import { useEffect } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import InfluencerNavbar from './components/InfluencerNavbar';
import InfluencerHero from './components/InfluencerHero';
import BeneficiosInfluencer from './components/BeneficiosInfluencer';
import ComoFuncionaInfluencer from './components/ComoFuncionaInfluencer';
import DepoimentosInfluencers from './components/DepoimentosInfluencers';
import FormularioInfluencer from './components/FormularioInfluencer';
import CTAInfluencer from './components/CTAInfluencer';
import Footer from '../home/components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const influencerSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Programa de Influencers | Parceria — Carta do Eu Futuro',
  url: `${SITE_URL}/influencer`,
  description: 'Seja um parceiro do Carta do Eu Futuro. Programa de afiliados e influencers para criadores de conteúdo de desenvolvimento pessoal, PNL e bem-estar.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Influencer', item: `${SITE_URL}/influencer` },
    ],
  },
};

export default function InfluencerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Programa de Influencers e Afiliados | Parceria — Carta do Eu Futuro"
        description="Seja um parceiro do Carta do Eu Futuro. Programa de afiliados e influencers para criadores de conteúdo de desenvolvimento pessoal, PNL e bem-estar."
        keywords="programa influencer, afiliados, parceria, desenvolvimento pessoal, PNL, criadores de conteúdo"
        canonical="/influencer"
        ogImage="https://public.readdy.ai/ai/img_res/2c9af9f5941fe125a49aad21cff09720.jpg"
        ogType="website"
        schema={influencerSchema}
      />
      <InfluencerNavbar />
      <InfluencerHero />
      <BeneficiosInfluencer />
      <div id="como-funciona">
        <ComoFuncionaInfluencer />
      </div>
      <div id="depoimentos">
        <DepoimentosInfluencers />
      </div>
      <CTAInfluencer />
      <FormularioInfluencer />
      <Footer />
    </div>
  );
}
